export const EMPTY_FLAGS: { code: string; enabled: boolean }[] = [];
